// React Query staleTime 常量
//
// 全局默认 staleTime 已在 main.jsx QueryClient.defaultOptions.queries 设为 30_000。
// 这里只列**与默认值不同**的几种档位,避免每个 useQuery 都手写数字。
// 30s 内不算 stale,不会自动 refetch;切 tab 回来直接用缓存。
//
// R6:加 LONG 档位(5 分钟),用于极少变更的字典 / 系统配置 / 用户信息等。
//   所有调用方应 import { STALE_TIME } from '../../constants/staleTime',不要写魔法数字。
export const STALE_TIME = {
  // 30s — 全局默认,绝大多数列表查询用这个
  DEFAULT: 30_000,
  // 60s — 业务聚合数据(Dashboard 卡片统计),允许稍长缓存
  MEDIUM: 60_000,
  // 5 min — 极少变更的数据(字典 / 系统配置 / 用户信息 / 数据字典)
  LONG: 5 * 60_000,
}
